import { createProjectionChangesInput } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';

import {
  SelectionFeatureKeys,
  type SelectionInputFeature,
  type SelectionProjectionLifecycle,
} from '../../features/types.ts';

export function createProjectionChangesInputFeature({
  databaseAdapter,
  projectionLifecycle,
}: {
  databaseAdapter: DatabaseAdapter;
  projectionLifecycle: SelectionProjectionLifecycle;
}): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.PROJECTION_CHANGES_INPUT,
    type: 'input',
    factory: (machine) =>
      createProjectionChangesInput(machine, databaseAdapter, {
        subscribe: projectionLifecycle.subscribe,
        isProjectionAvailable: projectionLifecycle.isAvailable,
      }),
  };
}
